import { render, staticRenderFns } from "./gc-batch-despatch-order.vue?vue&type=template&id=4e69350e&"
import script from "./gc-batch-despatch-order.vue?vue&type=script&lang=js&"
export * from "./gc-batch-despatch-order.vue?vue&type=script&lang=js&"
import style0 from "./gc-batch-despatch-order.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports